import logo from '~/assets/icons/logo.png';
import { Text } from '~/components/ui/Text';
import { StyledContainer, StyledLogoContainer } from './FormTitle.styled';

const FormTitle = ({ text }: { text: string }) => {
	return (
		<StyledContainer>
			<StyledLogoContainer>
				<img src={logo} width={20} height={20} />
				<Text>CCDPLANET</Text>
			</StyledLogoContainer>
			<Text
				style={{
					fontSize: 14,
					opacity: 0.5,
					color: '#ffffff',
					textAlign: 'center',
				}}
			>
				{text}
			</Text>
		</StyledContainer>
	);
};

export { FormTitle };
